module.exports = __webpack_public_path__ + "static/img/img (16).aa963795.jpg";